// Guards for the "send CV" modals.
//
// The panel posted `send_cv_lite_email` / `send_cv_email` with
// `offer_id: this.cv_offer.id` unconditionally. When the modal was opened from
// a context that carries no loaded offer, `offer_id` went out as undefined,
// the server ran `Offer.find(nil)` and answered a generic 500
// ("Event execution failed"). The recruiter saw an opaque server error and the
// CV email was never sent, with nothing telling her what was missing.
//
// Keep this message identical to Events::Main::MISSING_OFFER_MESSAGE in
// rebase_server, so the panel guard and the server 422 read the same.
export const MISSING_OFFER_MESSAGE =
  'לא נבחרה הצעה — יש לבחור הצעה לפני שליחת קורות חיים'

// True only when there is an offer with a usable id. `0` is not a valid offer
// id in this system, so the plain truthiness check is the right one.
export function hasSelectedOffer (offer) {
  return !!(offer && offer.id)
}

export default { MISSING_OFFER_MESSAGE, hasSelectedOffer }
